module.exports = __webpack_public_path__ + "img/footer-twitter.svg";